import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TopupPackOption } from '../../services/api.service';

@Component({
  selector: 'app-topup-pack-cards',
  templateUrl: './topup-pack-cards.component.html',
  styleUrls: ['./topup-pack-cards.component.css'],
})
export class TopupPackCardsComponent {
  /** Pack size that shows the "Most popular" badge. */
  readonly mostPopularPackSize = 100;

  @Input() packs: TopupPackOption[] = [];
  @Input() selectedPackSize: number | null = null;
  @Input() disabled = false;
  @Input() showSkip = false;
  @Input() buyLabel = 'Buy credits';
  @Input() skipLabel = 'Skip for now';
  @Input() expiryHint = 'Credits valid for 90 days after purchase';

  @Output() selectedPackSizeChange = new EventEmitter<number>();
  @Output() buy = new EventEmitter<number>();
  @Output() skip = new EventEmitter<void>();

  selectPack(pack: TopupPackOption): void {
    if (this.disabled) return;
    this.selectedPackSizeChange.emit(pack.packSize);
  }

  onBuy(): void {
    if (this.disabled || !this.selectedPackSize) return;
    this.buy.emit(this.selectedPackSize);
  }

  onSkip(): void {
    if (this.disabled) return;
    this.skip.emit();
  }

  formatZar(cents: number): string {
    return `R${(Math.max(0, cents) / 100).toFixed(2)}`;
  }

  unitPriceLabel(pack: TopupPackOption): string {
    return `${this.formatZar(Number(pack.unitPriceCents || 0))} / credit`;
  }

  isMostPopular(pack: TopupPackOption): boolean {
    return Number(pack.packSize) === this.mostPopularPackSize;
  }

  isSelected(pack: TopupPackOption): boolean {
    return Number(pack.packSize) === Number(this.selectedPackSize);
  }
}
